import Vue from "vue";

export const state = Vue.observable({
  context: {
    currentComponent: 0,
    currentStage: "development",
    currentLayout: "main",
    dev: true,
    // displayMode: 'component',
    displayMode: 'router',
  },
  devData: {
    classroomId: "ckbnlg0l6fpwh0767pvt7eeq4"
  }
});

export const contexts = {
  layouts: [
    ["main", "main-index"]
  ],
  stages: [
    ["development", "dev"],
    ["production", "index"]
  ]
}

export const componentList = [
  "CommunicationCenter",
  "ClassroomStats",
  "Advisor",
  "LiveClass",
];

export const getCurrentStage = () => {
  const stage = contexts.stages.find(stage => stage[0] === state.context.currentStage);
  return { k: stage[0], v: stage[1] }
}

export const getCurrentLayout = () => {
  const layout = contexts.layouts.find(layout => layout[0] === state.context.currentLayout);
  return { k: layout[0], v: layout[1] }
}

export const getCurrentComponent = () => {
  return componentList[state.context.currentComponent] + '-' + state.context.currentStage;
}
